export enum ChartTypes {
  BarChart,
  LineChart,
  AreaChart,
  PieChart,
}

export interface WaffleCell {
  colorIndex: number;
  itemName: string;
  itemPct: number;
}

export interface WaffleChartData {
  name: string;
  pct: number;
}